import React from 'react';
import cn from 'classnames';

import { useTheme } from 'providers/Theme.provider';
import { formatDayToYear, formatHourAndMinute } from 'utils/date/format.util';

import CN from './CashupTableRow.module.scss'; // common for deposit, cash and voucher tabs

const PettyCashLogItem = (props) => {
  const { isDarkMode } = useTheme();
  const displayTime = formatHourAndMinute(props.date);
  const displayDate = formatDayToYear(props.date);

  return (
    <div
      data-bem="PettyCashLogItem"
      className={cn({
        [CN.tableRow]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className={CN.fixedColumnCell}>
        <span>{displayTime} </span>
        <span>{displayDate}</span>
      </div>
      <div className={CN.cell}>
        <span>{props.pettyCash}</span>
      </div>
      <div
        className={cn({
          [CN.cell]: true,
          [CN.lgWidth]: true,
        })}
      >
        <span>{props.notes}</span>
      </div>
    </div>
  );
};

export default PettyCashLogItem;
